export default __webpack_public_path__ + "static/media/doc.0541dacb.png";